import React from "react";
import { useTheme } from "styled-components";

const SpacerAndDivider = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 9a.563.563 0 0 1-.562.563H2.813a.563.563 0 1 1 0-1.126h12.375A.56.56 0 0 1 15.75 9"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default SpacerAndDivider;
